import type { Editor } from '@tiptap/core';
import expandBlockSelection from './expandBlockSelection.helper';

// Reads the range a block would copy (expandBlockSelection), so a node around the selection does not count.
const selectionHasNode = (editor: Editor, nodeNames: ReadonlySet<string>): boolean => {
  const { selection, doc } = editor.state;
  if (selection.empty) return false;
  const { from, to } = expandBlockSelection(selection);
  let found = false;
  doc.slice(from, to).content.descendants((node) => {
    if (nodeNames.has(node.type.name)) found = true;
    return !found;
  });
  return found;
};

export default selectionHasNode;
